import { CommonModule } from '@angular/common';
import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import type { Observable } from 'rxjs';

import { IconComponent, InputComponent, Maybe } from '@evc/web-components';

import { PlatformTranslatePipe } from '../i18n/platform-translate.pipe';
import { SearchService } from './search.service';

@Component({
  selector: 'evc-search',
  imports: [
    CommonModule,
    FormsModule,
    PlatformTranslatePipe,
    InputComponent,
    IconComponent,
  ],
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchComponent implements OnInit {
  public readonly placeholder = input<Maybe<string>>();

  #searchService = inject(SearchService);
  searchText$?: Observable<string>;

  public ngOnInit(): void {
    this.searchText$ = this.#searchService.searchText$;
  }

  public searchMe(event: KeyboardEvent): void {
    this.#searchService.searchMe(event);
  }

  public clearSearch(): void {
    this.#searchService.clearSearch();
  }

  public onSearchTextChanged(value: string): void {
    this.#searchService.setSearchText(value);
  }
}
